import React from "react";
import "../styles/BookStorePage.css";
import { useCart } from "../contexts/CartContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const books = [
    { id: 1, title: "Yapay Zeka", description: "AI Temelleri", price: 120, image: "https://via.placeholder.com/150" },
    { id: 2, title: "Veri Bilimi", description: "Python ile analiz", price: 95, image: "https://via.placeholder.com/150" },
    { id: 3, title: "React Geliştirme", description: "Modern Web", price: 110, image: "https://via.placeholder.com/150" }
];

const BookStorePage = () => {
    const { addToCart } = useCart();

    return (
        <div className="bookstore-container">
            <h2>📚 Kitap Satışı</h2>
            <div className="book-list">
                {books.map(book => (
                    <div className="book-card" key={book.id}>
                        <img src={book.image} alt={book.title} />
                        <h3>{book.title}</h3>
                        <p>{book.description}</p>
                        <span className="price">{book.price}₺</span>
                        <button onClick={() => {
                            addToCart(book);
                            toast.success(`${book.title} sepete eklendi!`);
                        }}>
                            Sepete Ekle
                        </button>
                    </div>
                ))}
            </div>
            <ToastContainer position="top-right" autoClose={2000} />
        </div>
    );
};

export default BookStorePage;
